export function buildLiveUrl(baseUrl, params = [], allInputVars = []) {
  if (!baseUrl) return "";
  const queryRows = params.filter(p => p.type === "query" && p.key);
  if (!queryRows.length) return baseUrl;
  const qs = queryRows.map(p => {
    const val = p.source === "variable"
      ? (p.varName ? `\${${p.varName}}` : "?")
      : (p.literalValue || "");
    return `${encodeURIComponent(p.key)}=${encodeURIComponent(val).replace(/%24%7B/g,"${").replace(/%7D/g,"}")}`;
  }).join("&");
  return `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}${qs}`;
}
